<div class="mainstepcontent row w100">
  <div class="leftside col">
    <div class="col gap-16">
      <div class="col">
        <div class="stepcounter">
          STEP {{ thisStepCount }}/{{ totalStepCount }}
        </div>
        <h1>{{ step?.name }}</h1>
      </div>
      <!--
      <div
        class="instructions align-center row gap-8 pointer"
        (click)="openInstructions()"
      >
        <rr-icon name="info"></rr-icon>
        <div class="underline">Instructions</div>
      </div>
      -->
      <div class="instructions align-center row gap-8 pointer">
        <div class="secondary-text">
          Please classify ALL potential target users by clicking the green or
          red buttons.
        </div>
      </div>
      <div class="results col gap-8 w100">
        <div class="main-persona col gap-8" *ngIf="shoeMainPersona == true">
          <div class="results-heading">Main Persona</div>
          <div class="row gap-16 results-container">
            <div class="results-item pointer" (click)="openPriorizePersonas()">
              <div
                class="result-image"
                [style]="positivePersonas[0]?.image"
              ></div>
              <div class="result-label">{{ positivePersonas[0]?.name }}</div>
            </div>
          </div>
        </div>
        <div class="row space-between w100">
          <div class="results-heading">My Users</div>
          <div
            class="results-skipped"
            *ngIf="skippedPersonas.length > 0"
            (click)="showSkipped()"
          >
            Show Skipped
          </div>
        </div>
        <div class="row gap-16 results-container w100">
          <div class="results-icon">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="icon"
            >
              <path
                d="M13.3333 23.332C13.3333 23.332 15.8333 26.6654 19.9999 26.6654C24.1666 26.6654 26.6666 23.332 26.6666 23.332M14.9999 14.9987H15.0166M24.9999 14.9987H25.0166M36.6666 19.9987C36.6666 29.2034 29.2047 36.6654 19.9999 36.6654C10.7952 36.6654 3.33325 29.2034 3.33325 19.9987C3.33325 10.794 10.7952 3.33203 19.9999 3.33203C29.2047 3.33203 36.6666 10.794 36.6666 19.9987Z"
                stroke="#067A57"
                stroke-opacity="0.8"
                stroke-width="3.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <!-- <div
            *ngIf="personaQueue.length == 0 && positivePersonas.length === 0"
          >
            Please select minimum one positive Persona.
          </div> -->
          <div
            class="results-item pointer"
            *ngFor="let item of positivePersonas"
            (click)="removeSelection(item)"
          >
            <div class="result-image" [style]="item?.image"></div>
            <div class="result-label">{{ item?.name }}</div>
            <rr-icon name="trash" class="trashicon roundicon"></rr-icon>
          </div>
        </div>
        <div class="row gap-16 results-container w100">
          <div class="results-icon">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.3333 24.9987H26.6666M14.9999 14.9987H15.0166M24.9999 14.9987H25.0166M36.6666 19.9987C36.6666 29.2034 29.2047 36.6654 19.9999 36.6654C10.7952 36.6654 3.33325 29.2034 3.33325 19.9987C3.33325 10.794 10.7952 3.33203 19.9999 3.33203C29.2047 3.33203 36.6666 10.794 36.6666 19.9987Z"
                stroke="#C73A3A"
                stroke-opacity="0.8"
                stroke-width="3.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            class="results-item pointer"
            *ngFor="let item of negativePersonas"
            (click)="removeSelection(item)"
          >
            <div class="result-image" [style]="item.image"></div>
            <div class="result-label">{{ item.name }}</div>
            <rr-icon name="trash" class="trashicon roundicon"></rr-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="rightside">
    <div class="tinder" *ngIf="personaQueue.length >= 1">
      <div class="persona">
        <div class="persona-inner">
          <div class="icon-and-text">
            <div class="col gap-16">
              <div class="header">
                {{ personaQueue[0]?.name }}
              </div>
              <div class="subtitle">
                {{
                  personaQueue[0]?.occupation ||
                    personaQueue[0]?.demographics?.occupation
                }}
              </div>
              <div class="image save" [style]="personaQueue[0]?.image"></div>

              <div class="description">
                {{ personaQueue[0]?.short_summary }}
              </div>
            </div>
          </div>
          <div class="tag-group">
            <rr-badge *ngFor="let tag of personaQueue[0]?.values">{{
              tag
            }}</rr-badge>
          </div>
          <div class="action w100 grow-1 justify-end col">
            <rr-btn
              type="Secondary"
              tone="brand"
              iconEnd="arrow-down"
              class="w100"
              (click)="showFUllPersona()"
              >Show full persona</rr-btn
            >
          </div>
        </div>
        <div class="tinder-btn no-match" (click)="noMatchPersona()">
          <div class="tinder-btn-inner pointer">
            <svg
              width="87"
              height="87"
              viewBox="0 0 87 87"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29 54.375H58M32.625 32.625H32.6613M54.375 32.625H54.4113M79.75 43.5C79.75 63.5203 63.5203 79.75 43.5 79.75C23.4797 79.75 7.25 63.5203 7.25 43.5C7.25 23.4797 23.4797 7.25 43.5 7.25C63.5203 7.25 79.75 23.4797 79.75 43.5Z"
                stroke="#C73A3A"
                stroke-opacity="0.8"
                stroke-width="7.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div class="tinder-btn match" (click)="matchPersona()">
          <div class="tinder-btn-inner pointer">
            <svg
              width="87"
              height="87"
              viewBox="0 0 87 87"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M29 50.75C29 50.75 34.4375 58 43.5 58C52.5625 58 58 50.75 58 50.75M32.625 32.625H32.6613M54.375 32.625H54.4113M79.75 43.5C79.75 63.5203 63.5203 79.75 43.5 79.75C23.4797 79.75 7.25 63.5203 7.25 43.5C7.25 23.4797 23.4797 7.25 43.5 7.25C63.5203 7.25 79.75 23.4797 79.75 43.5Z"
                stroke="#067A57"
                stroke-opacity="0.8"
                stroke-width="7.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="personaQueue.length < 1" class="col">
      <div class="queueEnd">
        <div class="text-center">
          All potential users sorted.<br />
          move on with next step
        </div>
        <div class="row gap-8 align-center">
          <rr-btn type="Link" class="underline" (click)="restartAgain()"
            >Reset & Start Again</rr-btn
          >
        </div>
      </div>
    </div>
  </div>
</div>

<rr-spinner *ngIf="loading == true"></rr-spinner>
